export const GameActionEvent = 'gameaction';

export const GameActionType = {
    START: 'start',
    RESTART: 'restart',
    NEXT: 'next',
    SELECT: 'select',
    WARNING: 'warning',
    SHOW_RATINGS: 'show-ratings',
    CLOSE_RATINGS: 'close-ratings',
    SHOW_AUTHORS: 'show-authors',
    CLOSE_AUTHORS: 'close-authors',
    TOGGLESOUND: 'toggle-sound'
};
